import React, {useState} from 'react';
import ReviewScore from '../item/ReviewScore';
import styles from '../../styles/review/Review.module.scss';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faTrash, faComment, faCalendarAlt, faEllipsisH, faCheckCircle} from '@fortawesome/free-solid-svg-icons';



const UserReview = (props) => {
    const {info, editReview, handleDelete} = props;
    

    const handleEditReview = () => {editReview(info.id);}
    const removeReview = () => {handleDelete(info.id);}

    let response = info.hasOwnProperty('response') &&
                    <div className={styles.response}>
                        <p className={`${styles.responseHeader}`}>
                            <FontAwesomeIcon icon={faComment} width="16" height="16" className="me-2"/>
                            Răspuns {info.provider}
                        </p>
                        <p className="font-italic">{info.response}</p>
                    </div>;

    let options = <Dropdown className="">
                        <Dropdown.Toggle variant="link" id="dropdown-basic">
                            <FontAwesomeIcon icon={faEllipsisH} width="16" height="16" className="me-2"/>
                        </Dropdown.Toggle>
                    
                        <Dropdown.Menu>
                            <Dropdown.Item onClick={handleEditReview}>
                                <FontAwesomeIcon icon={faPen} width="16" height="16" className="me-2"/>
                                Editează
                            </Dropdown.Item>
                            <Dropdown.Item onClick={removeReview} >
                                <FontAwesomeIcon icon={faTrash} width="16" height="16" className="me-2"/>
                                Șterge
                            </Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>;

    let contact =   info.acceptContact && 
                    <Card.Text className={`${styles.info} text-muted`}>
                        <FontAwesomeIcon icon={faCheckCircle} width="16" height="16" className="me-2 green"/>
                        Ești de acord să fii contactat de {info.provider}, dacă instituția optează să ia legatură cu tine prin Conso
                    </Card.Text>;

    return(
        <Col xs="12" className={`${styles.root} mb-5 p-0`}>
            <Card>
                <Card.Header className="bg-green d-flex justify-content-between">
                    <span>
                        <strong>{info.product}</strong> de la {info.provider}
                    </span>
                    {options}
                </Card.Header>
                <Card.Body>
                    <ReviewScore rating={info.rating} />
                    <Card.Title className={`${styles.title} mt-3`}>
                        {info.title}
                    </Card.Title>
                    <Card.Text>
                        {info.review}
                    </Card.Text>
                    {contact}
                    {response}

                </Card.Body>
                <Card.Footer className={styles.data}>
                    <FontAwesomeIcon icon={faCalendarAlt} width="16" height="16" className="me-2"/>
                    Data postării: {info.data}
                </Card.Footer>
            </Card>
        </Col>

    );
}

export default UserReview;